import { createSlice } from "@reduxjs/toolkit";

export const drawerSlice = createSlice({
  name: "isOpen",
  initialState: {
    value: true,
  },
  reducers: {
    changeState: (state) => {
      state.value = !state.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeState } = drawerSlice.actions;

export default drawerSlice.reducer;
